<template>
  <div class="space-y-4">
    <Loading v-if="loading" />
    <div class="flex justify-end">
      <BaseButton @click="onCreate">Tambah</BaseButton>
    </div>
    <Datatable
      :columns="tableColumns"
      :total="orderDestinations.meta.page.total"
      :perPage="orderDestinations.meta.page.perPage"
      :currentPage="orderDestinations.meta.page.currentPage"
      @pagechanged="onChangePage"
    >
      <template #tbody="{ classes }">
        <tr
          v-for="orderDestination in orderDestinations.data"
          :key="orderDestination.id"
          :class="classes.tr"
        >
          <td :class="classes.td">
            {{ orderDestination.attributes.destination_office_code }}
          </td>
          <td :class="classes.td">
            {{ orderDestination.attributes.origin_office_code }}
          </td>
          <td :class="classes.td">
            <div class="flex gap-1">
              <BaseButton for-icon @click="onEdit(orderDestination)">
                <Icon
                  icon="heroicons:pencil-square-solid"
                  class="text-green-600"
                />
              </BaseButton>
              <BaseButton for-icon color="danger" @click="onDelete(orderDestination)">
                <Icon icon="heroicons:trash-solid" class="text-red-600" />
              </BaseButton>
            </div>
          </td>
        </tr>
      </template>
    </Datatable>
    <OrderDestinationFormModal
      :visible="formModal.visible"
      :id="formModal.id"
      @close="formModal.visible = false"
      @saved="loadOrderDestinations"
    />
    <OrderDestinationDeleteConfirm
      :visible="deleteConfirm.visible"
      :id="deleteConfirm.id"
      @close="deleteConfirm.visible = false"
      @deleted="loadOrderDestinations"
    />
  </div>
</template>

<script>
import { requestMixin } from '../../../mixins/request/request';
import OrderDestinationDeleteConfirm from './SetupKebijakanWilayahPenjualan/OrderDestinationDeleteConfirm.vue';
import OrderDestinationFormModal from './SetupKebijakanWilayahPenjualan/OrderDestinationFormModal.vue';

export default {
  mixins: [requestMixin],
  components: { OrderDestinationFormModal, OrderDestinationDeleteConfirm },
  props: {
  },
  data() {
    return {
      formModal: {
        id: null,
        visible: false,
      },
      deleteConfirm: {
        id: null,
        visible: false,
      },
      loading: false,
      orderDestinations: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    tableColumns() {
      return [
        { id: 'destination_office', name: 'Kantor Destinasi' },
        { id: 'origin_office', name: 'Kantor Tujuan' },
        { id: 'action', name: 'Aksi' },
      ];
    },
  },
  methods: {
    async loadOrderDestinations(params) {
      this.loading = true;

      const [res, err] = await this.request(`/api/v1/order-destinations`, {
        params: {
          'fields[order-destinations]':
            'origin_office_code,destination_office_code',
          sort: '-id',
          'page[size]': 5,
          ...params,
        },
      });

      if (!err) {
        this.orderDestinations = res;
      }

      this.loading = false;
    },
    onChangePage(page) {
      this.loadOrderDestinations({
        'page[number]': page,
      });
    },
    onCreate() {
      this.formModal.id = null;
      this.formModal.visible = true;
    },
    onEdit(orderDestination) {
      this.formModal.id = orderDestination.id;
      this.formModal.visible = true;
    },
    onDelete(orderDestination) {
      this.deleteConfirm.id = orderDestination.id;
      this.deleteConfirm.visible = true;
    },
  },
  created() {
    this.loadOrderDestinations();
  },
};
</script>
